import { useState } from "react";
import { useSearchParams } from "react-router-dom";
import { MultiCheck, useFilterOptions } from "@/components/admin/FilterBar";

const PRESETS = [["7", "Ultimi 7 giorni"], ["30", "Ultimi 30 giorni"], ["90", "Ultimi 90 giorni"], ["custom", "Personalizzato"]];
const ROLES = [["", "Tutti i ruoli"], ["azienda", "Azienda"], ["admin_sede", "Admin di sede"], ["super_admin", "Super admin"]];
const DEVICES = [["", "Tutti i dispositivi"], ["Desktop", "Desktop"], ["Tablet", "Tablet"], ["Mobile", "Mobile"]];

const Select = ({ id, label, value, options, onChange }) => (
    <div>
        <label htmlFor={id} className="edi-help block">{label}</label>
        <select id={id} className="edi-input" value={value} onChange={(e) => onChange(e.target.value)} data-testid={id}>
            {options.map(([v, l]) => <option key={v} value={v}>{l}</option>)}
        </select>
    </div>
);

export const AnalyticsFilters = ({ isSuper }) => {
    const [params, setParams] = useSearchParams();
    const opts = useFilterOptions();
    const custom = params.get("from") || params.get("to") || params.get("periodo") === "custom";
    const [preset, setPreset] = useState(custom ? "custom" : params.get("periodo") || "30");
    const [from, setFrom] = useState(params.get("from") || "");
    const [to, setTo] = useState(params.get("to") || "");
    const [error, setError] = useState("");
    if (isSuper && !opts) return null;

    const update = (mutate) => {
        const next = new URLSearchParams(params);
        mutate(next);
        next.delete("page");
        setParams(next);
    };
    const setOne = (k, v) => update((n) => (v ? n.set(k, v) : n.delete(k)));
    const setList = (k, values) => update((n) => { n.delete(k); values.forEach((v) => n.append(k, v)); });
    const choosePreset = (v) => {
        setPreset(v);
        setError("");
        if (v !== "custom") update((n) => { n.set("periodo", v); n.delete("from"); n.delete("to"); });
    };
    const applyCustom = () => {
        if (!from || !to) return setError("Indica la data iniziale e quella finale");
        if (from > to) return setError("La data iniziale deve precedere quella finale");
        setError("");
        return update((n) => { n.set("periodo", "custom"); n.set("from", from); n.set("to", to); });
    };
    const reset = () => {
        setPreset("30"); setFrom(""); setTo(""); setError("");
        const n = new URLSearchParams();
        if (params.get("vista")) n.set("vista", params.get("vista"));
        setParams(n);
    };

    return (
        <section aria-label="Filtri analytics" className="edi-card p-4 mb-6" data-testid="analytics-filters">
            <div className="grid gap-3 sm:grid-cols-2 xl:grid-cols-4 items-end">
                <Select id="an-periodo" label="Periodo" value={preset} options={PRESETS} onChange={choosePreset} />
                {isSuper && <MultiCheck name="spin" options={opts.spin.map((s) => ({ value: s.id, label: s.name }))} selected={params.getAll("spin")} onChange={(v) => setList("spin", v)} />}
                {isSuper && <MultiCheck name="regione" options={opts.regione.map((r) => ({ value: r, label: r }))} selected={params.getAll("regione")} onChange={(v) => setList("regione", v)} />}
                {isSuper && <Select id="an-ruolo" label="Ruolo" value={params.get("ruolo") || ""} options={ROLES} onChange={(v) => setOne("ruolo", v)} />}
                <Select id="an-dispositivo" label="Dispositivo" value={params.get("dispositivo") || ""} options={DEVICES} onChange={(v) => setOne("dispositivo", v)} />
            </div>
            {preset === "custom" && (
                <fieldset className="mt-3 flex flex-wrap items-end gap-3">
                    <legend className="font-medium mb-1">Periodo personalizzato</legend>
                    <div><label htmlFor="an-from" className="edi-help block">Dal</label><input id="an-from" type="date" className="edi-input" value={from} onChange={(e) => setFrom(e.target.value)} aria-invalid={error ? "true" : "false"} aria-describedby={error ? "an-period-error" : undefined} data-testid="an-from" /></div>
                    <div><label htmlFor="an-to" className="edi-help block">Al</label><input id="an-to" type="date" className="edi-input" value={to} onChange={(e) => setTo(e.target.value)} aria-invalid={error ? "true" : "false"} aria-describedby={error ? "an-period-error" : undefined} data-testid="an-to" /></div>
                    <button type="button" className="btn-secondary py-2" onClick={applyCustom} data-testid="an-period-apply">Applica periodo</button>
                </fieldset>
            )}
            {error && <p id="an-period-error" role="alert" className="edi-error mt-2" data-testid="an-period-error">{error}</p>}
            <button type="button" className="btn-ghost mt-3 underline" onClick={reset} data-testid="an-filter-reset">Azzera filtri</button>
        </section>
    );
};
